import { defineMessages } from "react-intl";

export const joinToGroupsGridMessages = defineMessages({
  discoverGroups: {
    defaultMessage: "Discover Groups",
    id: "join-to-groups-grid-messages.discover-groups",
  },
});
